export function PollingImportRequest(fetcher, form, onSuccess, onError, importAttendeeProcess = false) {
    const expectedStatus = importAttendeeProcess ? 'done' : 'valid';
    const interval = setInterval(() => {
        fetcher
            .get(form.importRequest.url, {
                allow_cache: false,
                cache: false
            })
            .then(({ response }) => {
                if (response.status === 'not-valid') {
                    onError();
                    clearInterval(interval);
                    return;
                }
                if (response.status !== expectedStatus) return;
                onSuccess(response);
                clearInterval(interval);
            });
    }, 3000);

    return () => clearInterval(interval);
}

export function tFallback(types, key) {
    return types?.map(type => key(type));
}
